global.ClientName1 = undefined;
global.ClientName2 = undefined;